export default __webpack_public_path__ + "static/media/22-min.8b39c3c4.jpg";